import { create } from 'zustand';
import { AdministracaoState, ModuloComTelas } from '../../types/administracao/administracaoTypes';

export const useAdministracaoStore = create<AdministracaoState>((set) => ({
  screensPermissions: [],
  loadingScreensPermisssions: true,
  setLoadingScreensPermisssions: (loading: boolean) => {
    set(() => ({ loadingScreensPermisssions: loading }))
  },
  setScreensPermissions: (screens: ModuloComTelas[]) => {
    set(() => ({ screensPermissions: screens }))
  },
  erroScreensPermisssions: false,
  setErroScreensPermisssions: (erro: boolean) => {
    set(() => ({ erroScreensPermisssions: erro }))
  },
  cleanAdministracaoStates: () => {
    set(() => ({ screensPermissions: [], loadingScreensPermisssions: false, erroScreensPermisssions: false }))
  }
}))